<section class="dialogContainer">
  <header class="dialogHeader">
    <ng-container #headerVcr></ng-container>
    <h4 *ngIf="!header?.tpl">{{ title }}</h4>
    <button type="button" class="close" (click)="close()">
        <i class="fa fa-window-close" aria-hidden="true"></i>
    </button>
  </header>

  <hr>
  <main>
    <ng-container #contentVcr></ng-container>
  </main>

  <footer>
    <ng-container #footerVcr></ng-container>
  </footer>
</section>
